import React from 'react';

import parseUrl from 'parse-url';

import type { PureLinkProperties } from './PureLink.types';

export const PureLink: React.FC<PureLinkProperties> = ({
  dataTest = 'pure_link',
  to,
  onClick,
  children,
  id,
  target,
  rel,
  referrerPolicy,
  style,
  disabled,
}) => {
  const [url, setUrl] = React.useState('');

  React.useEffect(() => {
    if (to) {
      try {
        setUrl(parseUrl(to, true).href);
      } catch {
        setUrl(to);
      }
    }
  }, [to]);

  return (
    <a
      data-testid={dataTest}
      href={url}
      onClick={onClick}
      id={id ?? dataTest}
      target={target}
      rel={rel}
      referrerPolicy={referrerPolicy}
      style={{
        ...style,
        pointerEvents: disabled ? 'none' : 'auto',
        opacity: disabled ? 0.5 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
    >
      {children}
    </a>
  );
};
